export enum Perfil {
  ALUNO_ESPECIAL = 'Aluno Especial',
  ALUNO_REGULAR = 'Aluno Regular',
  AREX = 'AREX',
  CANDIDATO = 'Candidato',
  CCD = 'CCD',
  CONSULTA_DISCENTE = 'Consulta de Discente',
  DTA = 'DTA',
  DOCENTE = 'Docente',
  PROPG = 'PROPG',
  RESIDENCIA = 'Residência',
  STPG = 'STPG',
}

export function getPerfilByDescription(value: string) {
  const indexOfS = Object.values(Perfil).indexOf(value as unknown as Perfil)
  const key = Object.keys(Perfil)[indexOfS]
  return key
}

export function getPerfilByKey(value: string) {
  const indexOfS = Object.keys(Perfil).indexOf(value as unknown as Perfil)
  const key = Object.values(Perfil)[indexOfS]
  return key
}
